export const SALT_STRING = 'qilinjinfu';
export const CODES = {
    SYS_ERROR: -1,
    SUCCESS: 1,
    GENERAL_ERROR: 2,
    REQ_NOT_AUTH: 3,
    REQ_NOT_NULL: 4,
    REQ_NOT_VALID: 5,
    NOT_LOGIN: 6,
    OP_NOT_AUTO: 7,
    UNKNOWN_ERROR: 9,
    EMAIL_NOT_REGISTERED: 10,
    EXCEED_RETRY_QUOTA: 11,
    PASSWORD_ERROR: 12,
    REQUEST_CHANNEL_TIMEOUT: 13,
    GET_RESULT_TIMEOUT: 21,
    REQUEST_CHANNEL_FAILED: 22,
    PAYMENT_FAILED: 23,
    ORDER_NOT_EXIST: 24,
    TRANS_NOT_PERMITTED: 25
}
